module.exports = __webpack_public_path__ + "img/white-logo-2.247eb6a1.png";